// extracted by mini-css-extract-plugin
export default {"text":"ComplainCompletedStep_text__3lNZu"};